"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9809],{

/***/ 9809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/organisms/headers/main/PC.js
var PC = __webpack_require__(4335);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/components/organisms/common/NotificationCenter.js + 1 modules
var NotificationCenter = __webpack_require__(2747);
// EXTERNAL MODULE: ./src/components/atoms/icons/Notify.js
var Notify = __webpack_require__(7068);
// EXTERNAL MODULE: ./src/components/atoms/photos/Avatar.js
var Avatar = __webpack_require__(3315);
// EXTERNAL MODULE: ./src/cds/icons/index.tsx
var icons = __webpack_require__(6643);
// EXTERNAL MODULE: ./src/cds/buttons/Icon.tsx
var Icon = __webpack_require__(7732);
// EXTERNAL MODULE: ./src/cds/buttons/Fill.tsx
var Fill = __webpack_require__(5549);
// EXTERNAL MODULE: ./src/cds/buttons/Outline.tsx
var Outline = __webpack_require__(5472);
// EXTERNAL MODULE: ./src/hooks/common/useStore.ts
var useStore = __webpack_require__(8004);
// EXTERNAL MODULE: ./src/hooks/bridge/useBridgeCallback.js
var useBridgeCallback = __webpack_require__(8372);
// EXTERNAL MODULE: ./src/hooks/common/useSearchModal.js
var useSearchModal = __webpack_require__(4970);
// EXTERNAL MODULE: ./src/hooks/common/useAccordingToScroll.js
var useAccordingToScroll = __webpack_require__(5571);
// EXTERNAL MODULE: ./src/lib/utils/deviceChecker.js
var deviceChecker = __webpack_require__(7496);
// EXTERNAL MODULE: ./src/lib/utils/helper.js
var helper = __webpack_require__(4058);
// EXTERNAL MODULE: ./src/cds/typography.ts
var typography = __webpack_require__(506);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/organisms/headers/main/Mobile.js





// components







// hooks




// utils


// styles


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 56px;\n\n  & > div:last-of-type {\n    height: inherit;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: inherit;\n  z-index: ",
        ";\n  box-sizing: content-box;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: inherit;\n  padding: 0 16px;\n  background-color: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 auto;\n  font-size: 0;\n\n  & > a {\n    display: block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 12px;\n  margin-left: 12px !important;\n  ",
        "\n  color: ",
        ";\n  background-color: transparent;\n  color: ",
        ";\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 12px;\n  ",
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  & ~ ",
        " {\n    margin-left: 6px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex: 0 auto;\n\n  & > * ~ * {\n    margin-left: 12px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 56px;\n  left: 0;\n  right: 0;\n  padding: 4px 16px 8px;\n  background-color: ",
        ";\n  transition: transform 0.2s ease;\n  transform: ",
        ";\n  z-index: calc(",
        " - 1);\n\n  & label {\n    display: block;\n    position: relative;\n    height: 44px;\n  }\n\n  & label,\n  & input {\n    width: 100%;\n  }\n\n  & input,\n  & input::placeholder {\n    ",
        "\n    color: ",
        ";\n  }\n\n  & input {\n    height: inherit;\n    padding: 0 44px 0 32px;\n    border: 1px solid ",
        ";\n    border-radius: 8px;\n    caret-color: ",
        ";\n    appearance: none;\n    outline: none;\n    background-color: transparent;\n\n    & ~ svg {\n      position: absolute;\n      top: 15px;\n    }\n\n    & ~ svg:first-of-type {\n      left: 14px;\n    }\n\n    & ~ svg:last-of-type {\n      right: 14px;\n      stroke: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n\n  & > div {\n    border: 1px solid white;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  & > div {\n    width: 100%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 2px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
/** 메인단 검색포함 헤더 */ var MainMobileHeader = function() {
    var onOpenNotify = function onOpenNotify() {
        var notifyEvent = new CustomEvent('onOpenNotify', {
            detail: {
                winWidth: window.outerWidth
            }
        });
        document.dispatchEvent(notifyEvent);
    };
    var router = (0,next_router.useRouter)();
    var ref = _slicedToArray((0,useStore/* useSelector */.v)(function(state) {
        return [
            state.user.info,
            state.user.newsCount.chat_unread_count,
            state.user.newsCount.news_unread_count, 
        ];
    }), 3), userInfo = ref[0], existChat = ref[1], existNotification = ref[2];
    var ref1 = (0,react.useState)(false), isIpadApp = ref1[0], setIsIpadApp = ref1[1];
    var ref2 = (0,react.useState)(false), isEnableNotify = ref2[0], setIsEnableNotify = ref2[1];
    var ref3 = (0,react.useState)(false), isVisibleNotify = ref3[0], setIsVisibleNotify = ref3[1];
    var isExistUser = userInfo.isLoaded && userInfo.id;
    var onOpenSearch = (0,useSearchModal/* default */.Z)().onOpenSearch;
    var ref4 = _slicedToArray((0,useAccordingToScroll/* default */.Z)({
        start: 0
    }), 2), stickyRef = ref4[0], isSticky = ref4[1];
    (0,useBridgeCallback/* default */.Z)({
        onOpenNotify: onOpenNotify
    });
    var onSearchSubmit = function(e) {
        return e.preventDefault();
    };
    var onLogin = function() {
        var loginRedirectUrl = (0,helper/* isExistWindow */.br)() ? window.location.pathname : '';
        router.push("/user?url=".concat(loginRedirectUrl));
    };
    var onToggleNotify = function() {
        if (!isExistUser) {
            onLogin();
            return;
        }
        setIsVisibleNotify(function(v) {
            return !v;
        });
    };
    var doOpenNotify = function(param) {
        var detail = param.detail;
        var winWidth = detail.winWidth;
        if (winWidth < styles/* mediaQuery.large */.cy.large) {
            return;
        }
        setIsVisibleNotify(true);
    };
    // ipadApp check
    (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        setIsIpadApp(device.iPadApp());
    }, []);
    /** 알림 아이콘 표시 여부 */ (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        if (device.app()) {
            setIsEnableNotify(false);
        } else {
            setIsEnableNotify(true);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!isEnableNotify) {
            return;
        }
        document.addEventListener('onOpenNotify', doOpenNotify);
        return function() {
            document.removeEventListener('onOpenNotify', doOpenNotify);
        };
    }, [
        isEnableNotify
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                                        name: "logo_white",
                                                        width: 110,
                                                        height: 20
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                                        name: "logo_symbol",
                                                        width: 12,
                                                        height: 13
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Service, {
                                        children: [
                                            !isExistUser && userInfo.isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat("https://www.classu.co.kr", "/class/open"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassApplyButton, {
                                                    size: "32px",
                                                    color: "".concat(styles/* palette.grey020 */.DG.grey020),
                                                    children: "클래스 개설"
                                                })
                                            }),
                                            isExistUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat("https://www.classu.co.kr", "/class/chat"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notify/* default */.Z, {
                                                    name: "ic_chat",
                                                    fill: styles/* palette.grey50 */.DG.grey50,
                                                    width: 24,
                                                    height: 24,
                                                    isActive: !!existChat
                                                })
                                            }),
                                            isExistUser && isEnableNotify && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                width: 24,
                                                height: 24,
                                                onClick: onToggleNotify,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notify/* default */.Z, {
                                                    name: "ic_alarm_s",
                                                    fill: styles/* palette.grey50 */.DG.grey50,
                                                    width: 24,
                                                    height: 24,
                                                    isActive: !!existNotification
                                                })
                                            }),
                                            isExistUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/user/".concat(userInfo.id),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarButton, {
                                                    as: "a",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                        width: 32,
                                                        height: 32,
                                                        src: userInfo.photo,
                                                        alt: userInfo.name
                                                    })
                                                })
                                            }),
                                            !isExistUser && userInfo.isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {
                                                size: "32px",
                                                color: styles/* palette.grey050 */.DG.grey050,
                                                onClick: onLogin,
                                                children: "로그인"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isIpadApp && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {
                                ref: stickyRef,
                                isSticky: isSticky,
                                onClick: onOpenSearch,
                                onSubmit: onSearchSubmit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "무엇을 배우고 싶나요?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                            name: "ic_number_sign_s",
                                            stroke: styles/* palette.red040 */.DG.red040,
                                            width: 16,
                                            height: 16
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                            name: "ic_search_top_bar",
                                            stroke: styles/* palette.grey070 */.DG.grey070,
                                            width: 16,
                                            height: 16
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                ]
            }),
            isExistUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCenter/* default */.Z, {
                    isVisible: isVisibleNotify,
                    onClose: onToggleNotify
                })
            })
        ]
    }));
};
var Wrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-bc37a3dd-0"
})(_templateObject());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc37a3dd-1"
})(_templateObject1(), styles/* zIndex.header */.W5.header);
var Inner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc37a3dd-2"
})(_templateObject2(), styles/* palette.system.BNB */.DG.system.BNB, styles/* zIndex.header */.W5.header);
var Logo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc37a3dd-3"
})(_templateObject3());
var LoginButton = (0,styled_components_browser_esm/* default */.ZP)(Outline/* default */.Z).withConfig({
    componentId: "sc-bc37a3dd-4"
})(_templateObject4(), typography/* subtitle4_medium */.b_, styles/* palette.grey080 */.DG.grey080, styles/* palette.grey75 */.DG.grey75, styles/* palette.system.grey */.DG.system.grey);
var ClassApplyButton = (0,styled_components_browser_esm/* default */.ZP)(Fill/* default */.Z).withConfig({
    componentId: "sc-bc37a3dd-5"
})(_templateObject5(), typography/* subtitle4_medium */.b_, styles/* palette.grey080 */.DG.grey080, styles/* palette.BTN.BG */.DG.BTN.BG, styles/* palette.grey50 */.DG.grey50, LoginButton);
var Service = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc37a3dd-6"
})(_templateObject6());
var SearchForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-bc37a3dd-7"
})(_templateObject7(), styles/* palette.system.BNB */.DG.system.BNB, function(param) {
    var isSticky = param.isSticky;
    return isSticky ? 'translate3d(0, -100%, 0)' : 'translate3d(0, 0, 0)';
}, styles/* zIndex.header */.W5.header, typography/* body2_regular */.Tk, styles/* palette.grey0 */.DG.grey0, styles/* palette.system.grey */.DG.system.grey, styles/* palette.red040 */.DG.red040, styles/* palette.grey0 */.DG.grey0);
var AvatarButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc37a3dd-8"
})(_templateObject8());
var NotifyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc37a3dd-9"
})(_templateObject9());
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc37a3dd-10"
})(_templateObject10());
/* harmony default export */ var Mobile = (MainMobileHeader);

// EXTERNAL MODULE: ./src/components/layout/Head.js
var Head = __webpack_require__(9604);
// EXTERNAL MODULE: ./src/components/organisms/common/SideBar.js + 1 modules
var SideBar = __webpack_require__(9772);
// EXTERNAL MODULE: ./src/components/molecules/common/Footer.js
var Footer = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/hooks/common/useWebview.js
var useWebview = __webpack_require__(4639);
;// CONCATENATED MODULE: ./src/components/layout/Body.js



// components


// hooks

// utils

// styles

function Body_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Body_templateObject() {
    var data = Body_taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  z-index: 0;\n"
    ]);
    Body_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Body_templateObject1() {
    var data = Body_taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n\n  ",
        " {\n    width: 240px;\n  }\n"
    ]);
    Body_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Body_templateObject2() {
    var data = Body_taggedTemplateLiteral([
        "\n  flex: 0 auto;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n\n  ",
        " {\n    max-width: calc(100% - 240px);\n  }\n"
    ]);
    Body_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 콘텐츠 영역 레이아웃
 * @param {object} props
 * @param {boolean} props.disableFooter
 */ var BodyLayout = function(param) {
    var disableFooter = param.disableFooter, children = param.children;
    var isWebview = (0,useWebview/* default */.Z)().isWebview;
    var ref = (0,react.useState)(false), isIpadApp = ref[0], setIsIpadApp = ref[1];
    // ipadApp check
    (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        setIsIpadApp(device.iPadApp());
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Left, {
                    id: "left-side",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBar/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Right, {
                    id: "right-side",
                    children: [
                        children,
                        !isWebview && !isIpadApp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                            disableFooter: disableFooter
                        })
                    ]
                })
            ]
        })
    }));
};
var Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9b9396e5-0"
})(Body_templateObject());
var Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9b9396e5-1"
})(Body_templateObject1(), styles/* mediaQuery.large */.cy.large);
var Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9b9396e5-2"
})(Body_templateObject2(), styles/* mediaQuery.large */.cy.large);
/* harmony default export */ var Body = (BodyLayout);

;// CONCATENATED MODULE: ./src/components/layout/index.js

// comonents




/**
 * 메인 레이아웃
 * @param {import('react').PropsWithChildren<{mobileHeader?:JSX.Element;disableFooter?:boolean}>}
 */ var layout_Layout = function(param) {
    var _mobileHeader = param.mobileHeader, mobileHeader = _mobileHeader === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile, {}) : _mobileHeader, _disableFooter = param.disableFooter, disableFooter = _disableFooter === void 0 ? false : _disableFooter, children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {
                mobile: mobileHeader,
                pc: /*#__PURE__*/ (0,jsx_runtime.jsx)(PC/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                disableFooter: disableFooter,
                children: children
            })
        ]
    }));
};
/* harmony default export */ var layout = (layout_Layout);


/***/ }),

/***/ 4970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var slices_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6419);
/* harmony import */ var hooks_common_useStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8004);
/* harmony import */ var hooks_common_useModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5042);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3887);


// slices

// hooks


// styles

/**
 * 탐색 모달 Hook
 *
 * @example
 * const { onOpenSearch } = useSearchModal();
 *
 * return (
 *   <button onClick={onOpenSearch}>검색 모달 열기</button>
 * );
 */ var useSearchModal = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var dispatch = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I)();
    var initModal = (0,hooks_common_useModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().initModal;
    /** 탐색 모달 열기 */ var onOpenSearch = function() {
        router.push("".concat(router.asPath, "#search"));
        initModal({
            name: 'Search'
        });
    };
    var checkSearch = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var isExist = /#search/gi.test(router.asPath);
        if (isExist && window.innerWidth < cds_styles__WEBPACK_IMPORTED_MODULE_5__/* .mediaValue.large */ .T8.large) {
            initModal({
                name: 'Search'
            });
        } else if (isExist) {
            dispatch((0,slices_modal__WEBPACK_IMPORTED_MODULE_2__/* .deleteModal */ .pT)('Search'));
        }
    }, [
        dispatch,
        router.asPath,
        initModal
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return checkSearch();
    }, [
        checkSearch
    ]);
    return {
        onOpenSearch: onOpenSearch
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSearchModal);


/***/ })

}]);